import { SET_SORT_DEALER } from '../constants/actionTypes';

export const setSortDealer = (payload) => ({
  type: SET_SORT_DEALER,
  payload
});
